import { FC } from 'react'
import { AppRouter } from './AppRouter'
import styles from './app.module.scss'
import NotificationMessages from '../components/NotificationMessages'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { InternalTesterBadge } from '../components/InternalTesterBadge'
import { useGetSelfQuery } from '../reactQuery/useGetSelfQuery'

export const App: FC = () => {
  const { isLoading } = useGetSelfQuery()

  return (
    <div className={styles.app}>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <ErrorBoundary label="App">
          <AppRouter />

          <NotificationMessages />

          <InternalTesterBadge />
        </ErrorBoundary>
      )}
    </div>
  )
}
